var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/StudentEditor/StudentEditor.css';

var $ = require('jquery');
var StudentRes = require('../../resources/student');
import notification from '../Modal/notification';
import createNotificationDialog from '../Modal/createNotificationDialog';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'school', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

var StudentEditor = React.createClass({
    componentWillReceiveProps: function(nextProps) {
    // this.setState({})
    },
    componentDidUpdate: function(prevProps) {
        window.onbeforeunload = function() {
            return '';
        }
    },
    componentWillUnmount: function() {
        window.onbeforeunload = function() {
            return undefined;
        }
    },
    componentDidMount: function() {

        var _this = this;
        var statusMode = this.state.statusMode;
        statusMode = STUDENT_STATUSES;
        var currentUser = Auth.getCurrentUser();
        // console.log("currentUser id is " + currentUser._id);
        // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
        // if (currentUser.role === 'admin') {
        //   statusMode = ADMIN_STATUSES;
        // } else  {
        //   statusMode = TEACHER_STATUSES;
        // }
        var currentMode = statusMode[0];

        // if (this.props.location.query.mode) {
        //   var mode = this.props.location.query.mode,
        //       mappedMode = statusMode.filter((value) => {
        //         return value.code === mode
        //       })[0];
        //   if (mappedMode) currentMode = mappedMode;
        // }

        // var addedList = _this.state.addedStudentsList;

        this.setState({
          isLoading: true,
          statusMode: statusMode,
          currentMode: currentMode,
          
        }, function() {
          // var count = statusMode.length;
          // for (var i = 0; i < statusMode.length; i++) {
          //   this.countCollectionInMode(statusMode[i], function() {
          //     count--;
          //     if (count <= 0) _this.forceUpdate();
          //   });
          // }

          var currentURL = window.location.href;
          if (currentURL.indexOf("edit")!==-1) {

            var currentURL = window.location.href;
            currentURL = currentURL.split("/");
            var studentID = currentURL[currentURL.length-1]; //get the current class ID
            this.retrieveStudent(studentID);
          } 
        //   else {
        //     this.retrieveStudents();
        //   }
          
        });
    },
    retrieveStudent: function(studentID,callback) {
        callback = callback || function(){};
        var _this = this;
        // var currentPager = this.state.currentPager;
        var options = {};
        // options.skip = ITEM_LIMIT * (currentPager - 1);
        // options.limit = ITEM_LIMIT;
        // options.sort = this.state.sort || "dateCreated";
        options.conditions = {};
        // options.conditions.status = {
        //   "$in": this.state.currentMode.value
        // }
        // if (!this.state.currentMode.canApplyAdminRole) {
        //   options.conditions.creator = Auth.getCurrentUser()._id;
        // }
        // if (this.state.currentMode.include) {
        //   options.include = this.state.currentMode.include;
        //   options.includeConditions = includeConditions[options.include];
        // }
            // console.log("state of mdoe is " + this.state.currentMode.cols);
        
        // var currentURL = window.location.href;
        // currentURL = currentURL.split("/");

        // var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

        options.conditions.sort = this.state.sort || "firstName";
        // options.conditions.status = 'student';
        options.conditions.studentID = studentID;

        // var firstN = '';
        // var lastN = '';
        // if (fName) { firstN = fName; }
        // if (lName) { lastN = lName; }

        // options.conditions.sort = this.state.sort || "dateCreated";
        options.conditions.status = 'student';
        // options.conditions.firstName = firstN;
        // options.conditions.lastName = lastN;
        StudentRes.retrieveStudent(options, function(err, res) {
        // console.log("BEFORE DON sdfdsfsE!!");
        // if (callback) return callback(err, res);

        // console.log("RES IS :" + res.lastName);
            _this.setState({
                displayStudentName: 'Edit Student',
                displayButtonText: 'UPDATE STUDENT',
                // student: {
                    _id: studentID,
                    studentName : res.firstName + " " + res.lastName,
                    isLoading: false,
                    firstName: res.firstName,
                    lastName: res.lastName,
                    email: res.email,
                    phone: res.phone,
                    residentialAddress: res.metadata.residentialAddress,
                    // metadata: {
                    //     residentialAddress: res.metadata.residentialAddress,
                    //     schoolName: res.metadata.schoolName,
                    //     class: res.metadata.class,
                    //     SA2Grade: res.metadata.SA2Grade,
                    //     parentName: res.metadata.parentName,
                    //     parentNo: res.metadata.parentNo,
                    //     parentEmail: res.metadata.parentEmail,
                    // },
                    school: res.metadata.school,
                    schoolClass: res.metadata.class,
                    SA2Grade: res.metadata.SA2Grade,
                    parentName: res.metadata.parentName,
                    parentNo: res.metadata.parentNo,
                    parentEmail: res.metadata.parentEmail,
                    // student: {
                    //     _id: studentID,
                    //     studentName : res.firstName + " " + res.lastName,
                    //     firstName: res.firstName,
                    //     lastName: res.lastName,
                    //     email: res.email,
                    //     phone: res.phone,
                    //     residentialAddress: res.metadata.residentialAddress,
                    //     metadata: {
                    //         residentialAddress: res.metadata.residentialAddress,
                    //         schoolName: res.metadata.schoolName,
                    //         class: res.metadata.class,
                    //         SA2Grade: res.metadata.SA2Grade,
                    //         parentName: res.metadata.parentName,
                    //         parentNo: res.metadata.parentNo,
                    //         parentEmail: res.metadata.parentEmail,
                    //     },
                    //     schoolName: res.metadata.schoolName,
                    //     schoolClass: res.metadata.class,
                    //     SA2Grade: res.metadata.SA2Grade,
                    //     parentName: res.metadata.parentName,
                    //     parentNo: res.metadata.parentNo,
                    //     parentEmail: res.metadata.parentEmail,
                    //     status: "student",
                    //     password: ""
                    // }
                // }
                // studentsData: (!err && res) ? res: [{}]
                }, () => {

                    // var sData = _this.state.studentsData;
                    // for (var i = 0; i < sData.length; i++) {

                    //     var thisData = sData[i];
                    //     var dDate = thisData['lastActivityDate'];
                    //     var processDate = new Date(dDate);
                    //     var dateToDisplay = processDate.toDateString();
                    //     if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
                    //     thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
                    // }

                    // _this.setState({
                    //     studentsData: sData
                    // });
                // console.log("DONE!!!");
                }
            );
        })
    },
    getInitialState: function() {
        var _this = this;
        var initialState = {
            displayStudentName: 'New Student',
            displayButtonText: 'CREATE STUDENT',
            statusMode: "",
            currentMode: "",
            studentName : "",
            isLoading: false,
            firstName: "",
            lastName: "",
            email: "",
            password:"",
            phone: "",
            residentialAddress: "",
            school: "",
            schoolClass: "",
            SA2Grade: "",
            parentName: "",
            parentNo: "",
            parentEmail: "",
            createdByTeacher: "",
            student: {
                _id: "",
                studentName : "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                residentialAddress: "",
                createdByTeacher: "",
                metadata: {
                    createdByTeacher: "",
                    residentialAddress: "",
                    school: "",
                    class: "",
                    SA2Grade: "",
                    parentName: "",
                    parentNo: "",
                    parentEmail: "",
                },
                school: "",
                schoolClass: "",
                SA2Grade: "",
                parentName: "",
                parentNo: "",
                parentEmail: "",
                status: "student",
                password: ""
            }
        }
        return initialState;
    },
  handleChangeData: function(field, e) {
    // console.log("STUDENT ID IS " + this.state._id);
    //   console.log("CHANGING INPUT " + field + " e is " + e.target.value);
    var update = {};
    var _this = this;
    var student = _this.state.student;
    student[field] = e.target.value;
    update[field] = e.target.value;
    this.setState(update, function (){

        this.setState({ student:student});
    });
  },
  generatePassword: function() {
    var ranString = this.genRandomString(8);
    this.setState({
    
        password:ranString
    });
  },
  genRandomString:function(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 },
  saveStudent: function(callback) {
    var _this = this;
    var student = _this.state.student;
    var studentName = _this.state.studentName;//student.studentName;

    //TODO: get current teacher/admin's ID
    var currentUser = Auth.getCurrentUser();
    var createdByTeacher = currentUser._id; //current user (teacher/admin's id)
    // console.log("CURRENT USER ID IS " + createdByTeacher);

    //get first and last name from the student name
    var splitName = studentName.split(" ");
    var firstName = splitName[0];
    var lastName = splitName[1];

    student.firstName = firstName;
    student.lastName = lastName;

    var studentEmail = _this.state.email//student.email;

    var studentPassword = _this.state.password;
    var mobileNumber = _this.state.phone;//student.phone;
    var residentialAddress = _this.state.residentialAddress;//student.residentialAddress;
    var school = _this.state.school;//student.schoolName;
    var schoolClass = _this.state.schoolClass;//student.schoolClass;
    var saGrade = _this.state.SA2Grade;//student.SA2Grade;
    var parentName = _this.state.parentName;//student.parentName;
    var parentNo = _this.state.parentNo;//student.parentNo;
    var parentEmail = _this.state.parentEmail;//student.parentEmail;

    student.studentName = studentName;
    student.password = studentPassword;
    student.email = studentEmail;
    student.phone = mobileNumber;
    student.residentialAddress = residentialAddress;
    student.school = school;
    student.schoolClass = schoolClass;
    student.parentName = parentName;
    student.parentNo = parentNo;
    student.parentEmail = parentEmail;
    student.createdByTeacher = createdByTeacher;

    //set up the metadata (e.g class name etc)
    student.metadata.school = school;
    student.metadata.class = schoolClass;
    student.metadata.SA2Grade = saGrade;
    student.metadata.residentialAddress = residentialAddress;
    student.metadata.parentName = parentName;
    student.metadata.parentNo = parentNo;
    student.metadata.parentEmail = parentEmail;
    student.metadata.createdByTeacher = createdByTeacher;

    if (_this.state._id) { student._id = _this.state._id; }

    //generate a random string for the password
    console.log("studentName is " + _this.state.studentName);
        
    var ifError = false;

    if (!studentName || !studentEmail || !mobileNumber || !residentialAddress || !school || !schoolClass || !saGrade
        || !parentName || !parentNo || !parentEmail) { ifError = true; }

    if (ifError) {

        return notification.open({
            message: 'Cannot Add Student',
            description: 'All fields are required'
        })
        
        // return;
    } 
    else {

        $("body, html").addClass("heavy-load");

        if (_this.state._id) {

            this.setState({
                student: student
            }, () => {

                StudentRes.saveStudent(student, (err, res) => {
                    $("body, html").removeClass("heavy-load");
                    if (callback) return callback(err, res);
                    if (err) {
                        return notification.open({
                        message: 'Error',
                        description: 'Cannot save student. Please try again'
                        })
                    }
                    this.setState({
                        student: res
                    }, () => {
                        notification.open({
                        message: 'Success',
                        description: "Student has been saved!"
                        })
                        browserHistory.push('/student/' + _this.state._id);
                        // if (_this.state.isCreateNew) browserHistory.push('/students');
                    });

                });
            });

        } else {

            StudentRes.saveStudent(student, (err, res) => {
                $("body, html").removeClass("heavy-load");
                if (callback) return callback(err, res);
                if (err) {
                    return notification.open({
                    message: 'Error',
                    description: 'Cannot save student. Please try again'
                    })
                }
                this.setState({
                    student: res
                }, () => {
                    notification.open({
                    message: 'Success',
                    description: "Student has been saved!"
                    })
                    browserHistory.push('/students');
                    // if (_this.state.isCreateNew) browserHistory.push('/students');
                })
            })
        }
        
    }
    

    // var titleValidation = !!(collection.title && collection.title.trim());
    // if (!titleValidation) {
    //   return this.refs["EditorStep1"].invalidTitleOnSave();
    // }
    // var longQValidation = this.validateLongQuestionData();
    // if (!longQValidation.isValid) {
    //   collection.questions[longQValidation.invalidSumMarkQuestionIndex].kquestion.sumMarkError = true;
    //   this.dialogNotification = createNotificationDialog({
    //     title: 'Cannot Save',
    //     content: 'Question ' + (longQValidation.invalidSumMarkQuestionIndex+1) + ': sum of part\'s mark should be equal to question\'s mark'
    //   }, function() {
    //     _this.setState({
    //       collection: collection,
    //       openNotificationDialog: false
    //     });
    //   })
    //   this.setState({
    //     openNotificationDialog: true
    //   })
    //   return;
    // }
    // $("body, html").addClass("heavy-load");
    // var updatedConcept = this.getChosenConcept();
    // var subject = Helpers.getSubject(this.conceptsMap, updatedConcept._id);
    // if (!collection.metadata) collection.metadata = {};
    // collection.metadata.subjectName = subject.title;
    // collection.metadata.conceptName = this.conceptLeafMapping[updatedConcept._id].title;
    // collection.concepts = [updatedConcept._id];
    // for (var i = 0; i < collection.questions.length; i++) {
    //   collection.questions[i].kquestion.concepts = [updatedConcept._id];
    // }
    // this.setTypeForTextInputAnswers();
    // CollectionRes.saveCollection(collection, (err, res) => {
    //   $("body, html").removeClass("heavy-load");
    //   if (callback) return callback(err, res);
    //   if (err) {
    //     return notification.open({
    //       message: 'Error',
    //       description: 'Cannot save collection. Please try again'
    //     })
    //   }
    //   this.setState({
    //     collection: res
    //   }, () => {
    //     notification.open({
    //       message: 'Success',
    //       description: "Collection has been saved!"
    //     })
    //     if (_this.state.isCreateNew) browserHistory.push('/collections');
    //   })
    // })
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            <h3> {_this.state.displayStudentName} </h3>

            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Student Name</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'studentName')} value={_this.state.studentName} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Email</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'email')} value={_this.state.email} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Password</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'password')} value={_this.state.password} />
                    <RaisedButton
                        target="_blank"
                        label={"Generate password"}
                        primary={false}
                        onClick={this.generatePassword.bind(_this, null)}
                    />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Mobile Number</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'phone')} value={_this.state.phone} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Address</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'residentialAddress')} value={_this.state.residentialAddress} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">School Name</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'school')} value={_this.state.school} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Class</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'schoolClass')} value={_this.state.schoolClass} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Latest SA1/2 Grade</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'SA2Grade')} value={_this.state.SA2Grade} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Name</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'parentName')} value={_this.state.parentName} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Telephone</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'parentNo')} value={_this.state.parentNo} />
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Parent's Email</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'parentEmail')} value={_this.state.parentEmail} />
                </div>
            </div>
            <br/><br/>
            <div className="content-toolbar">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent"></label>
                </div>
                <div className="createButton">
                    
                    <RaisedButton
                        target="_blank"
                        label={_this.state.displayButtonText}
                        primary={true}
                        onClick={this.saveStudent.bind(_this, null)}
                    />
                    {/*<RaisedButton
                    onClick={this.saveStudent.bind(_this, null)}
                    target="_blank"
                    label="Create Student"
                    primary={true}
                    icon={<i style={{"color": "white"}} className="fa fa-save" />}
                    />*/}
                </div>
            </div>
        
        </div>
    );
  }

});

export default StudentEditor;



/** WEBPACK FOOTER **
 ** ./src/components/StudentEditor/StudentEditor.js
 **/